import { useEffect, useState } from 'react';
import { Alert, Box, Button } from '@mui/material';
import api from '../../../../api';
import { pickSelectedId } from '../../../../utils/funcoes';
import DataList from '../../../form/DataList';
import ProfissoesDialog from './ProfissoesDialog';

export default function PessoaProfissaoField({ module }) {
    const { dados } = module.state;
    const { selecionarProfissao } = module.actions;
    const [options, setOptions] = useState([]);
    const [erro, setErro] = useState('');
    const [open, setOpen] = useState(false);
    const [versao, setVersao] = useState(0);
    const descricao = dados.profissaoDescricao || '';
    const id = dados.profissaoId;
    useEffect(() => {
        let vigente = true;
        const timer = setTimeout(async () => {
            try {
                const { data } = await api.get('/profissao/listar', { params: { q: descricao, ativo: 'true' } });
                if (!Array.isArray(data.data)) throw new Error('Resposta inválida ao consultar profissões.');
                if (vigente) { setOptions(data.data.map(p => ({ ...p, label: '' }))); setErro(''); }
            } catch (e) { if (vigente) { setOptions([]); setErro(e.response?.data?.message || e.message); } }
        }, 250);
        return () => { vigente = false; clearTimeout(timer); };
    }, [descricao, versao]);
    // Compatibilidade com consultas de Pessoas que retornam apenas o ID.
    useEffect(() => {
        if (!id || descricao) return undefined;
        let vigente = true;
        api.get(`/profissao/consultar/${id}`).then(({ data }) => {
            if (vigente) selecionarProfissao(data.id, data.descricao);
        }).catch(e => { if (vigente) setErro(e.response?.data?.message || e.message); });
        return () => { vigente = false; };
    }, [id, descricao, selecionarProfissao]);
    function alterar(e) {
        const value = e.target.value || '';
        const selectedId = pickSelectedId(value, options);
        const selected = options.find(p => Number(p.id) === Number(selectedId));
        selecionarProfissao(selected?.id || null, selected?.descricao || value);
    }
    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <DataList text="Profissão" name="pessoaFisica.profissaoDescricao" inputWidth="350px"
                    value={descricao} filteredOptions={options} handleOnChange={alterar} />
                <Button type="button" variant="outlined" onClick={() => setOpen(true)}>Gerenciar profissões</Button>
                {(id || descricao) && <Button type="button" onClick={() => selecionarProfissao(null, '')}>Limpar profissão</Button>}
            </Box>
            {descricao && !id && <Alert severity="info">Selecione uma opção da lista ou cadastre a profissão.</Alert>}
            {erro && <Alert severity="error">{erro}</Alert>}
            <ProfissoesDialog open={open} onClose={() => setOpen(false)}
                onChanged={p => { setVersao(v => v + 1); if (p && Number(p.id) === Number(id)) selecionarProfissao(p.id, p.descricao); }}
                onSelect={p => { selecionarProfissao(p.id, p.descricao); setOpen(false); }} />
        </Box>
    );
}
